export const FREE_DRAWING = "FreeDrawing";
export const FILLED_RECTANGLE = "FilledRectangle";
export const DASHED_RECTANGLE = "DashedRectangle";
export const FILLED_CIRCLE = "FilledCircle";
export const DASHED_CIRCLE = "DashedCircle";
export const LINE = "Line";
export const ARROW = "Arrow";
export const TEXT = "Text";
export const MARKER = "Marker";
export const TRIANGLE = "Triangle";
export const FILLED_TRIANGLE = "FilledTriangle";

export default {
  FREE_DRAWING,
  FILLED_RECTANGLE,
  DASHED_RECTANGLE,
  FILLED_CIRCLE,
  DASHED_CIRCLE,
  ARROW,
  TEXT,
  LINE,
  MARKER,
  TRIANGLE,
  FILLED_TRIANGLE
};
